import common from './common'
import {CodeToText} from 'element-china-area-data';

let padDate = va => {
  va = va < 10 ? '0' + va : va;
  return va
};
/**
 * 日期统一处理
 * @param val
 * @returns {{seconds: (string|*), month: (string|*), hour: (string|*), year: number, minutes: (string|*), day: (string|*)}}
 */
let formateDateCommon = (val) =>{
  if(!val) return {};
  let value = new Date(val);
  let year = value.getFullYear();
  let month = padDate(value.getMonth() + 1);
  let day = padDate(value.getDate());
  let hour = padDate(value.getHours());
  let minutes = padDate(value.getMinutes());
  let seconds = padDate(value.getSeconds());
  return {year,month,day,hour,minutes,seconds};
};
/**
 * 处理金额为 ##,###,###,###.XXX 格式(只加逗号,不处理小数)
 * @param val
 * @returns {string}
 */
let formateMoney = val =>{
  val = val.toString();
  let arr = val.split('.');
  let integerStr = '';
  let i = arr[0].length;
  while (i > 0) {
    let temp = arr[0].substring(i - 3, i);
    if (temp.length < 3 || i - 3 <= 0) {
      integerStr = temp + integerStr;
    } else {
      integerStr = ',' + temp + integerStr;
    }
    i -= 3;
  }
  if (arr[1]) {
    integerStr += '.' + arr[1];
  }
  return integerStr;
};
/**
 * 处理保留多少位小数
 * @param val 待处理数值
 * @param num 保留的位数
 * @returns {string | * | *}
 */
let formateToFiex = (val,num)=>{
  return val.toFixed(num);
};
/**
 * 给金额添加'￥'符号
 * @param val
 * @returns {string}
 */
let formateMoneySign = (val) =>{
  return '￥' + val;
};
/**
 * 给数字添加'%'符号,
 * @param val 待处理数字
 * @param num 保留多少位小数
 * @returns {string}
 */
let formateRateSign = (val,num) =>{
  val = (val * 100).toFixed(num);
  return val + '%';
}
export default {
  /**
   * 格式化日期为 yyyy
   * @param val
   * @returns {string}
   */
  formatYear: function (val) {
    let {year} = formateDateCommon(val);
    return year;
  },
  /**
   * 格式化日期为 yyyy-mm
   * @param val
   * @returns {string}
   */
  formatMonth: function (val) {
    let {year,month} = formateDateCommon(val);
    return year?year + '-' + month:'';
  },
  /**
   * 格式化日期为 yyyy-mm-dd
   * @param val
   * @returns {string}
   */
  formatDay: function (val) {
    let {year,month,day} = formateDateCommon(val);
    return year?year + '-' + month + '-' + day:'';
  },
  /**
   * 格式化日期为 yyyy-mm-dd hh:mm
   * @param val
   * @returns {string}
   */
  formatMinutes: function (val) {
    let {year,month,day,hour,minutes} = formateDateCommon(val);
    return year?year + '-' + month + '-' + day + ' ' + hour + ':' + minutes:'';
  },
  /**
   * 格式化日期为 yyyy-mm-dd hh:mm:ss
   * @param val
   * @returns {string}
   */
  formatDate: function (val) {
    let {year,month,day,hour,minutes,seconds} = formateDateCommon(val);
    return year?year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds:'';
  },

  /**
   * 格式化数值保留一位小数 ####.#
   * @param val
   * @returns {string|*}
   */
  formateNumber1(val){
    return formateToFiex(val,1);
  },
  /**
   * 格式化数值保留两位小数 ####.##
   * @param val
   * @returns {string|*}
   */
  formateNumber2(val){
    return formateToFiex(val,2);
  },
  /**
   * 格式化数值保留四位小数 ####.####
   * @param val
   * @returns {string|*}
   */
  formateNumber4(val){
    return formateToFiex(val,4);
  },
  /**
   * 格式化数值保留八位小数 ####.########
   * @param val
   * @returns {string|*}
   */
  formateNumber8(val){
    return formateToFiex(val,8);
  },

  /**
   * 格式化金额保留一位小数 #,###.#
   * @param val
   * @returns {string|*}
   */
  formateMoney1(val){
    val = formateToFiex(val,1);
    return formateMoney(val);
  },
  /**
   * 格式化金额保留两位小数 #,###.##
   * @param val
   * @returns {string|*}
   */
  formateMoney2(val){
    val = formateToFiex(val,2);
    return formateMoney(val);
  },
  /**
   * 格式化金额保留四位小数 #,###.####
   * @param val
   * @returns {string|*}
   */
  formateMoney4(val){
    val = formateToFiex(val,4);
    return formateMoney(val);
  },
  /**
   * 格式化金额保留八位小数 #,###.########
   * @param val
   * @returns {string|*}
   */
  formateMoney8(val){
    val = formateToFiex(val,8);
    return formateMoney(val);
  },

  /**
   * 格式化数值保留一位小数,添加'￥'符号 ￥####.#
   * @param val
   * @returns {string|*}
   */
  formateNumberSign1(val){
    val = formateToFiex(val,1);
    return formateMoneySign(val);
  },
  /**
   * 格式化数值保留两位小数,添加'￥'符号 ￥####.##
   * @param val
   * @returns {string|*}
   */
  formateNumberSign2(val){
    val = formateToFiex(val,2);
    return formateMoneySign(val);
  },
  /**
   * 格式化数值保留四位小数,添加'￥'符号 ￥####.####
   * @param val
   * @returns {string|*}
   */
  formateNumberSign4(val){
    val = formateToFiex(val,4);
    return formateMoneySign(val);
  },
  /**
   * 格式化数值保留八位小数,添加'￥'符号 ￥####.########
   * @param val
   * @returns {string|*}
   */
  formateNumberSign8(val){
    val = formateToFiex(val,8);
    return formateMoneySign(val);
  },

  /**
   * 格式化金额保留一位小数,添加'￥'符号 ￥#,###.#
   * @param val
   * @returns {string|*}
   */
  formateMoneySign1(val){
    val = formateToFiex(val,1);
    val = formateMoney(val);
    return formateMoneySign(val);
  },
  /**
   * 格式化金额保留两位小数,添加'￥'符号 ￥#,###.##
   * @param val
   * @returns {string|*}
   */
  formateMoneySign2(val){
    val = formateToFiex(val,2);
    val = formateMoney(val);
    return formateMoneySign(val);
  },
  /**
   * 格式化金额保留四位小数,添加'￥'符号 ￥#,###.####
   * @param val
   * @returns {string|*}
   */
  formateMoneySign4(val){
    val = formateToFiex(val,4);
    val = formateMoney(val);
    return formateMoneySign(val);
  },
  /**
   * 格式化金额保留八位小数,添加'￥'符号 ￥#,###.########
   * @param val
   * @returns {string|*}
   */
  formateMoneySign8(val){
    val = formateToFiex(val,8);
    val = formateMoney(val);
    return formateMoneySign(val);
  },

  /**
   * 格式化百分比不保留小数,添加'￥'符号 ￥#,###.#
   * @param val
   * @returns {string|*}
   */
  formateRateSign0(val){
    return formateRateSign(val,0);
  },
  /**
   * 格式化百分比保留一位小数,添加'￥'符号 ￥#,###.##
   * @param val
   * @returns {string|*}
   */
  formateRateSign1(val){
    return formateRateSign(val,1);
  },
  /**
   * 格式化百分比保留两位小数,添加'￥'符号 ￥#,###.####
   * @param val
   * @returns {string|*}
   */
  formateRateSign2(val){
    return formateRateSign(val,2);
  },

  /**
   * 去除掉输入值的空格
   * @param val
   * @returns {*}
   */
  trimFilter(val){
    return val&&val.tostring().trim()||val;
  },
  /**
   * 根据地区编码获取对应的地区名称
   * @param location
   * @returns {string}
   */
  getCodeText(location){
    if(!location) return '';
    let arr = location.split(',');
    let str = '';
    arr.forEach(code=>{
      str += CodeToText[code] + '/'
    });
    str = str.slice(0,str.length-1);
    return str;
  },
}



// WEBPACK FOOTER //
// ./src/service/filters.js